<template>
  <div>
    <ol v-if="forced_dashboard === true" class="breadcrumb mb-3">
      <li v-for="(breadcrumb, index) in forced_breadcrumbs" :key="`${breadcrumb.title}-${index}`">
        <template v-if="index === forced_breadcrumbs.length - 1">
          <span>{{ $t(breadcrumb.title) }}</span>
        </template>
        <template v-else>
          <router-link :to="{ name: breadcrumb.route }">{{ $t(breadcrumb.title) }}</router-link>
        </template>
      </li>
    </ol>

    <ol v-if="current_breadcrumbs.length > 0" class="breadcrumb mb-3">
      <li v-for="(breadcrumb, index) in current_breadcrumbs" :key="`${breadcrumb.title}-${index}`">
        <template
          v-if="
            breadcrumb.title === 'autocaller_v2.task.index.title' || breadcrumb.title === 'autocaller_v2.monitoring.index.title' || breadcrumb.title === 'autocaller_v2.monitoring_general.index.title'"
        >
          <span>{{ $t(breadcrumb.title) }} {{ $route.params.name }}</span>
        </template>

        <template v-else-if="index === current_breadcrumbs.length - 1">
          <span>{{ $t(breadcrumb.title) }}</span>
        </template>
        <template v-else>
          <router-link :to="breadcrumb.route">{{ $t(breadcrumb.title) }}</router-link>
        </template>
      </li>
    </ol>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    props: {
      forced_dashboard: {
        type: Boolean,
        default: false
      },
      forced_breadcrumbs: {
        type: Array,
        default: () => []
      }
    },
    computed: {
      ...mapGetters('shared/breadcrumbs', { current_breadcrumbs: 'current' })
    }
  };
</script>
